<template>
    <e-field>
        <e-select
            :model-value="selectedValue"
            :placeholder="placeholder"
            @change="handleChange"
        >
            <option v-for="option in options" :key="option.value" :value="option.value">
                {{ option.label }}
            </option>
        </e-select>
    </e-field>
</template>

<script>
export default {
    name: 'DropdownFilterItem',

    emits: ['update:model-value'],

    props: {
        filter: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'Select an option',
        },
        applyFilter: {
            type: Function,
            required: true,
        },
    },

    computed: {
        selectedValue() {
            return this.modelValue === false ? null : this.modelValue;
        },
    },

    methods: {
        handleChange(event) {
            const { value } = event.target;
            this.$emit('update:model-value', value);
            this.applyFilter(this.filter, value);
        },
    },
};
</script>
